<template>
    <div class="main-body">
        <div class="header">
            请假记录
        </div>
        <div class="out">

            <div class="search2">
              <el-button size="mini" type="primary" @click.native="toggleModalAdd">添加</el-button>
              <div style="clear: both;"></div>
            </div>



            <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">

                <el-table-column prop="userName" label="姓名"></el-table-column>

                <el-table-column prop="beginTime" label="开始时间"></el-table-column>

                <el-table-column prop="endTime" label="结束时间"></el-table-column>

                <el-table-column prop="remarks" label="请假原因"></el-table-column>

                <el-table-column prop="createTime" :formatter="formatTime" label="记录时间"></el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:options="options" v-on:closeAdd="closeAdd" v-on:getList="getList" v-on:openLeave="openLeave"></Add>
        <Leave ref="myLeave" v-show="showModalLeave" v-bind:options="options" v-on:closeLeave="closeLeave" v-on:getList="getList"></Leave>


    </div>
</template>

<script>
    import Add from "./Add";
    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import Leave from "./Leave"

    export default {
        name: "Page",
        data(){
            return{
                loading:false,
                menuButtonList:null,
                disabledAdd:true,
                showModalAdd:false,
                showModalEdit:false,
                showModalLeave:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                options:[]
            }
        },
        components:{
            Add,Leave
        },
        created(){
            this.init();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{

            init(){
                this.getList();
            },
            openLeave(data){
                this.closeLeave()
                this.$refs.myLeave.init(data);
            },
            closeLeave:function(){
                this.showModalLeave = !this.showModalLeave;
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"LeaveRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.init();
            },
            //格式化时间（2020-05-13T10:38:19.000+0800）
            formatTime:function (row, column, cellValue) {
                return timefilters(cellValue)
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },

        }
    }
</script>

<style scoped>

</style>
